import React, { Component } from 'react'
import block from 'bem-cn-lite';
import { I18n } from 'react-i18next'

const b = block('ProofingPanel');

class ProofingPanel extends Component {

    render() {

        const { commentsIsActive } = this.props

        return(
            <I18n>
            {
                (t) => (
                    <div className={b()}>
                        <div className={b('versions')}>
                            <div className={b('btn')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" className={b('btn-icon')}>
                                    <g fill="#FFF" fillOpacity=".9" fillRule="evenodd" opacity=".32">
                                        <path d="M11.5 0C5.175 0 0 5.175 0 11.5S5.175 23 11.5 23 23 17.825 23 11.5 17.825 0 11.5 0zm0 21C6.275 21 2 16.725 2 11.5S6.275 2 11.5 2 21 6.275 21 11.5 16.725 21 11.5 21z"/>
                                        <path d="M11.5 6H10v6l5.2 3.2.8-1.3-4.5-2.7"/>
                                    </g>
                                </svg>
                                <div className={b('btn-text')}>{t('global:versions')}</div>
                            </div>
                        </div>
                        <div className={b('container')}>{this.props.children}</div>
                        <div className={b('comments')}>
                            <div className={b('btn', { active: commentsIsActive })}>
                                {
                                    commentsIsActive ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" className={b('btn-icon')}>
                                            <path fill="#48F" fillRule="evenodd" d="M2.00495 0C.89765 0 0 .88976 0 2.0036V25l5-5h17.00258C23.10572 20 24 19.1018 24 18.0092V1.9908C24 .8913 23.10297 0 21.99505 0H2.00495zM15 13H6v-1h9v1zM6 9h12v1H6V9zm0-2V6h12v1H6z"/>
                                        </svg>
                                    :

                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" className={b('btn-icon')}>
                                            <path fill="#FFF" fillRule="evenodd" d="M2.00495 0C.89765 0 0 .88976 0 2.0036V25l5-5h17.00258C23.10572 20 24 19.1018 24 18.0092V1.9908C24 .8913 23.10297 0 21.99505 0H2.00495zm.98685 2C2.44405 2 2 2.45093 2 2.99477V21l3-3h16.00004C21.5523 18 22 17.55537 22 16.99913V3.00087C22 2.4481 21.5447 2 21.0082 2H2.9918zM15 13H6v-1h9v1zM6 9h12v1H6V9zm0-2V6h12v1H6z" opacity=".32"/>
                                        </svg>
                                }

                                <div className={b('btn-text')}>{t('global:comments')}</div>
                            </div>
                        </div>

                    </div>
                )
            }
            </I18n>
            
        )
    }
}

export default ProofingPanel